import { render } from "./RestartICE.vue?vue&type=template&id=5d2a1882&lang=pug"
import script from "./RestartICE.vue?vue&type=script&lang=js"
export * from "./RestartICE.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kevinpark/work/chekt-app-ham/web/home/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
